export default "__VITE_ASSET__806c89a9__"